export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const AZURE_CLIENT_ID = import.meta.env.VITE_API_AZURE_CLIENT_ID;
export const AZURE_TENANT_ID = import.meta.env.VITE_API_AZURE_TENANT_ID;
export const AZURE_REDIRECT_URI = import.meta.env.VITE_API_AZURE_REDIRECT_URI;
export const SENTRY_DSN = import.meta.env.VITE_API_SENTRY_DSN;

export const PRINT_SERVICE_URL = import.meta.env.VITE_API_PRINT_SERVICE_URL;
export const PRINT_SERVICE_API_KEY = import.meta.env.VITE_API_PRINT_SERVICE_API_KEY;